const hero = document.querySelector(".hero");
const heroVideo = hero?.querySelector(".hero__video") ?? null;
const mediaToggle = hero?.querySelector(".hero__media-toggle") ?? null;

let heroInView = false;
let manuallyPaused = false;

function updateMediaToggleState() {
  if (!mediaToggle) {
    return;
  }

  const actionLabel = manuallyPaused
    ? mediaToggle.dataset.playLabel
    : mediaToggle.dataset.pauseLabel;

  mediaToggle.classList.toggle("is-paused", manuallyPaused);
  if (actionLabel) {
    mediaToggle.setAttribute("aria-label", actionLabel);
  }
  mediaToggle.setAttribute("aria-pressed", manuallyPaused ? "true" : "false");
}

function playVideoWithRetry(video) {
  if (!video || video.tagName !== "VIDEO") {
    return Promise.resolve();
  }

  const attempt = () => {
    video.muted = true;
    return video.play();
  };

  return attempt().catch(() => {
    return new Promise((resolve) => {
      if (video.readyState >= 2) {
        void attempt().finally(() => resolve());
        return;
      }

      const cleanup = () => {
        video.removeEventListener("loadedmetadata", onReady);
        video.removeEventListener("canplay", onReady);
        video.removeEventListener("error", onError);
      };

      const onReady = () => {
        cleanup();
        void attempt().finally(() => resolve());
      };

      const onError = () => {
        cleanup();
        resolve();
      };

      video.addEventListener("loadedmetadata", onReady, { once: true });
      video.addEventListener("canplay", onReady, { once: true });
      video.addEventListener("error", onError, { once: true });
    });
  });
}

function startHeroVideo() {
  if (!heroVideo) {
    return;
  }

  void playVideoWithRetry(heroVideo);
}

function stopHeroVideo() {
  if (!heroVideo) {
    return;
  }

  heroVideo.pause();
}

function syncHeroPoster(video) {
  if (!video || video.tagName !== "VIDEO") {
    return;
  }

  const mobile = video.dataset.posterMobile;
  const desktop = video.dataset.posterDesktop;

  if (!mobile || !desktop) {
    return;
  }

  const mq = window.matchMedia(
    "(max-width: 768px) and (orientation: portrait)",
  );

  const apply = () => {
    video.poster = mq.matches ? mobile : desktop;
  };

  apply();

  if (typeof mq.addEventListener === "function") {
    mq.addEventListener("change", apply);
  } else {
    mq.addListener(apply);
  }
}

if (hero && heroVideo) {
  syncHeroPoster(heroVideo);
  updateMediaToggleState();

  mediaToggle?.addEventListener("click", () => {
    manuallyPaused = !manuallyPaused;
    updateMediaToggleState();

    if (manuallyPaused) {
      stopHeroVideo();
      return;
    }

    if (heroInView) {
      void playVideoWithRetry(heroVideo);
    }
  });

  const observer = new IntersectionObserver(
    (entries) => {
      const [entry] = entries;
      heroInView = entry.isIntersecting;

      if (heroInView && !manuallyPaused) {
        startHeroVideo();
        return;
      }

      stopHeroVideo();
    },
    { threshold: 0.15 },
  );

  observer.observe(hero);
}
